export const verificarCompatibilidadeVideo = (file) => {
    return new Promise((resolve) => {
        const MAX_VIDEO_DURATION = 15;

        // 1. Cria um elemento de vídeo invisível em memória
        const video = document.createElement('video');
        video.preload = 'metadata';

        // 2. Cria uma URL temporária segura para o arquivo binário enviado pelo lojista
        const fileURL = URL.createObjectURL(file);
        video.src = fileURL;

        // 3. Evento disparado quando o navegador consegue ler os metadados (Duração e Codecs)
        video.onloadedmetadata = () => {
            // Revoga a URL imediatamente para não vazar memória
            URL.revokeObjectURL(fileURL);

            const duration = video.duration;

            // Validação de Duração
            if (duration > MAX_VIDEO_DURATION) {
                resolve({ 
                    valido: false, 
                    motivo: `O vídeo ultrapassa o limite permitido de ${MAX_VIDEO_DURATION} segundos (Duração atual: ${Math.round(duration)}s).` 
                });
                return;
            }

            // Sucesso: O navegador conseguiu decodificar os metadados e a duração está correta
            resolve({ valido: true });
        };

        // 4. Se o codec for bizarro ou incompatível, o navegador falhará imediatamente ao ler o arquivo
        video.onerror = () => {
            URL.revokeObjectURL(fileURL);
            resolve({ 
                valido: false, 
                motivo: "Este formato ou codec de vídeo não é suportado. Por favor, utilize um vídeo padrão MP4 gravado por um smartphone." 
            });
        };
    });
};